import Swiper, { A11y, Navigation } from "@/lib/swiper";

export default function (element, dataset) {
  // Get carousel elements
  const carouselEl = element.querySelector('[data-element="carousel"]');
  const nextButton = element.querySelector('[data-element="next-button"]');
  const prevButton = element.querySelector('[data-element="prev-button"]');

  if (!carouselEl) {
    console.warn('tool-benefits-carousel: [data-element="carousel"] not found');
    return;
  }

  // Derive wrapper and slide classes from DOM structure
  const wrapperEl = carouselEl.querySelector(':scope > *');
  const slideEl = wrapperEl?.querySelector(':scope > *');
  const wrapperClass = wrapperEl?.className?.trim().split(/\s+/)[0] || 'swiper-wrapper';
  const slideClass = slideEl?.className?.trim().split(/\s+/)[0] || 'swiper-slide';

  // Generate unique ID for accessibility
  const carouselId = `tool-benefits-carousel-${Math.random().toString(36).substr(2, 9)}`;

  // Initialize Swiper carousel
  const swiperInstance = new Swiper(carouselEl, {
    modules: [A11y, Navigation],
    direction: 'horizontal',
    slidesPerView: 1.1,
    spaceBetween: 16,
    speed: 750,
    containerModifierClass: 'carousel-',
    slideActiveClass: 'carousel-slide-active',
    wrapperClass,
    slideClass,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
      disabledClass: 'is-disabled',
    },
    breakpoints: {
      480: {
        slidesPerView: 1.2
        ,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 2.5,
      },
      1280: {
        slidesPerView: 3,
      },
    },
    a11y: {
      containerMessage: 'Tool Vorteile Carousel',
      prevSlideMessage: 'Vorheriger Tool Vorteil',
      nextSlideMessage: 'Nächster Tool Vorteil',
      slideLabelMessage: 'Tool Vorteil {{index}} von {{slidesLength}}',
      firstSlideMessage: 'Das ist der erste Tool Vorteil',
      lastSlideMessage: 'Das ist der letzte Tool Vorteil',
      notificationClass: 'carousel_notification',
      slideRole: 'listitem',
      id: carouselId,
    },
  });

  // Add initialized class
  element.setAttribute('data-initialized', true);

  // Cleanup
  return () => {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      element.setAttribute('data-initialized', false);
    }
  };
}
